import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { BaseService } from '../../core/services/base.service';
import { map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { ActiveUserListService } from 'src/app/core/services/activeUserList.service';
import { IResponse } from 'src/app/shared/models/app';

@Injectable({
  providedIn: 'root'
})

export class AlertsService extends BaseService {
  markAsViewedTriggered$: Subject<any> = new Subject<any>();

  constructor(protected http: HttpClient, private activeuserService: ActiveUserListService) {
    super(http);
  }

  addCard(filterRequest: any = {}): Observable<any> {
    // const url= super.serviceUrl(this.dashboardUrl,UserApi.GetExternalUser);
    const url = this.apiConfig.util+"/api/alert"
    return super.fetch(url).pipe(map((response: IResponse) => {
      if (response.data) {
        response.data.forEach(alert => {
          alert.createdByName = this.activeuserService.getUserFirstName(alert.createdBy);
        });
        return response;
      }

    }));
  }

  getAlerts() {
    const url = this.apiConfig.config+"/api/hl7/alerts";
    return super.fetch(url)
  }

  getAlertCount() {
    const url = this.apiConfig.util+"/api/alert/count";
    return super.fetch(url)
  }

  getHl7Messages(dateField) {
    let currDate = moment(dateField)
    let requestedUrl = '';
    const url = this.apiConfig.config+'/api/hl7/messages';

    requestedUrl = url + "?date=" + currDate.format();
    return super.fetch(url, { params: { date: currDate.format() } });
  }

  deleteAlertForMe(alertID) {
    const url = this.apiConfig.util+'/api/alert/';

    return super.put(url + alertID, null).pipe(map((response: any) => {
      return response;
    }));
  }

  deleteAlertForDepartment(alertID) {
    const url = this.apiConfig.util+'/api/alert/';

    return super.delete(url + alertID).pipe(map((response: any) => {
      return response;
    }));
  }


  dismissAlert(alertID) {
    const url = this.apiConfig.config+'/api/hl7/alerts/delete/';
    return super.put(url + alertID, null);
  }

  dismissAllAlerts() {
    const url = this.apiConfig.config+'/api/hl7/alerts/deleteAll';
    return super.put(url, null);
  }

  retryAlert(alertID) {
    const url = this.apiConfig.config+'/api/hl7/'
    return super.put(url + alertID, null);
  }

  getActiveUsers() {
    const url = this.apiConfig.util+'/api/userManagement/users?onlyActiveUsers=Y';
    return super.fetch(url).pipe(map((res: any) => {
      if (!res.hasError) {
        res.data.forEach(user => {
          user.fullName = user.lastName + ', ' + user.firstName;
        });
        return res;
      }
    }));
  }

  saveNewAlert(data) {
    const url = this.apiConfig.util+'/api/alert';
    return super.post(url, data);
  }

  markAsViewed() {
    const req = {};
    const url =this.apiConfig.util+ '/api/alert/viewed';
    return super.post(url, req);
  }

  searchTheranosticsProcedures(data,type,pageNo){
    const url =super.serviceUrl(
      this.apiConfig.patient+
      '/api/alert/theranostics/patient/searchall?visit-type='+type+'&page='+pageNo)
    return super.post(url,data);
  }
  searchTheranosticsUnscheduledProcedures(data,pageNo,showCancel){
    const url =super.serviceUrl(this.apiConfig.patient+
      '/api/alert/theranostics/patient/searchall?visit-type=unscheduled'+'&page='+pageNo+'&show-cancellation='+showCancel);
    return super.post(url,data);
  }

  archiveManufacturerOrder(reservationId: number) {
    return super.put(this.apiConfig.config + '/api/config/orderstub/reservation/archive/' + reservationId, {});
  }


}
